import { render, staticRenderFns } from "./EditPaymentProvisionForm.vue?vue&type=template&id=a61890c8&scoped=true&"
import script from "./EditPaymentProvisionForm.vue?vue&type=script&lang=js&"
export * from "./EditPaymentProvisionForm.vue?vue&type=script&lang=js&"
import style0 from "./EditPaymentProvisionForm.vue?vue&type=style&index=0&id=a61890c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61890c8",
  null
  
)

export default component.exports